import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  FaUser, FaSearch, FaPlus, FaSave, FaTimes, FaBox,
  FaMoneyBillWave, FaArrowLeft, FaFileAlt, FaCheck,
  FaTrash, FaEdit, FaBoxes, FaClipboardList, FaUserPlus,
  FaPhone, FaEnvelope, FaIdCard, FaCar, FaFileInvoice,
  FaMinus, FaCalculator,
  FaMapMarkerAlt, FaBuilding, FaHome, FaCity, FaMapPin,
  FaRoad, FaGlobeAmericas, FaCheckCircle, FaTimesCircle, FaSpinner,
  FaStickyNote, FaChevronDown, FaChevronUp, FaExclamationTriangle
} from 'react-icons/fa';
import Header from '../others/Header';
import config from '../config/config';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../components/ToastContext';
import { decodeToken } from "react-jwt";
import InputMask from 'react-input-mask';
import { consultarCnpj, completarComDadosCnpj, avisoCompletarCnpj } from '../others/consultaCnpj';
import ImportarPrintCliente, { ESTILO_CAMPO_DO_PRINT, cepVeioDoPrint } from '../components/ImportarPrintCliente';

function ordenarProdutosPorPrioridade(produtos) {
  if (!produtos || produtos.length === 0) return [];
  const normalizarNome = (nome) => (nome || '').toLowerCase().trim();
  const prioritarios = produtos
    .filter(p => p.prioridade === true)
    .sort((a, b) => normalizarNome(a.nome).localeCompare(normalizarNome(b.nome), 'pt-BR'));
  const demais = produtos
    .filter(p => p.prioridade !== true)
    .sort((a, b) => normalizarNome(a.nome).localeCompare(normalizarNome(b.nome), 'pt-BR'));
  return [...prioritarios, ...demais];
}

function OrdemServico() {
  const { API_BASE_URL } = config;
  const navigate = useNavigate();
  const { id } = useParams();
  const { addToast } = useToast();

  const [formOrdem, setFormOrdem] = useState({
    idOrdemServico: null,
    dataAbertura: new Date().toISOString().split('T')[0],
    observacoes: '',
    valor: 0
  });

  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const [todosProdutos, setTodosProdutos] = useState([]);
  // Filtro da lista completa de produtos disponíveis (só na tela, não busca no servidor)
  const [filtroProdutos, setFiltroProdutos] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [modoListaCompleta, setModoListaCompleta] = useState(true);
  const [mostrarObservacoes, setMostrarObservacoes] = useState(false);

  const [modalPesquisaClienteAberto, setModalPesquisaClienteAberto] = useState(false);
  const [modalCadastroClienteAberto, setModalCadastroClienteAberto] = useState(false);

  const [termoPesquisaCliente, setTermoPesquisaCliente] = useState('');
  const [resultadosPesquisaCliente, setResultadosPesquisaCliente] = useState([]);
  const [buscandoCliente, setBuscandoCliente] = useState(false);
  const [mostrarBotaoCadastroCliente, setMostrarBotaoCadastroCliente] = useState(false);

  const [termoPesquisaProduto, setTermoPesquisaProduto] = useState('');
  const [resultadosPesquisaProduto, setResultadosPesquisaProduto] = useState([]);
  const [buscandoProduto, setBuscandoProduto] = useState(false);
  const [issqn, setIssqn] = useState(0);

  const formClienteVazio = () => ({
    nome: '', identidade: '', cpf: '', cnpj: '', telefone: '', email: '',
    logradouro: '', numero: '', bairro: '', complemento: '', cep: '', cidade: '', uf: ''
  });

  const [novoCliente, setNovoCliente] = useState(formClienteVazio());
  const [cadastrandoCliente, setCadastrandoCliente] = useState(false);
  const [errorsCliente, setErrorsCliente] = useState({});
  // Campos alterados pela leitura do print (Ctrl+V), destacados em amarelo até o formulário ser fechado
  const [camposDoPrintCadastro, setCamposDoPrintCadastro] = useState([]);
  // CEP preenchido pelo print: enquanto não mudar, sair do campo CEP não busca o endereço na API
  const [cepDoPrintCadastro, setCepDoPrintCadastro] = useState('');

  const [cpfStatus, setCpfStatus] = useState(null);
  const [cnpjStatus, setCnpjStatus] = useState(null);
  const [cpfMessage, setCpfMessage] = useState('');
  const [cnpjMessage, setCnpjMessage] = useState('');

  // ── CORREÇÃO: estados do modal de EDIÇÃO de cliente já cadastrado ──────────
  const [modalEdicaoClienteAberto, setModalEdicaoClienteAberto] = useState(false);
  const [clienteEditando, setClienteEditando] = useState(null);
  const [formEdicao, setFormEdicao] = useState(formClienteVazio());
  const [errorsEdicao, setErrorsEdicao] = useState({});
  const [camposDoPrintEdicao, setCamposDoPrintEdicao] = useState([]);
  const [cepDoPrintEdicao, setCepDoPrintEdicao] = useState('');
  const [salvandoEdicao, setSalvandoEdicao] = useState(false);
  const [cpfStatusEdicao, setCpfStatusEdicao] = useState(null);
  const [cnpjStatusEdicao, setCnpjStatusEdicao] = useState(null);
  const [cpfMessageEdicao, setCpfMessageEdicao] = useState('');
  const [cnpjMessageEdicao, setCnpjMessageEdicao] = useState('');
  const [loadingCepEdicao, setLoadingCepEdicao] = useState(false);

  // ── NOVO: modal de sucesso ao salvar a ordem (fechar / ver-imprimir / protocolo / nova ordem) ──
  const [modalSucessoAberto, setModalSucessoAberto] = useState(false);
  const [idOrdemSalva, setIdOrdemSalva] = useState(null);
  const [gerandoRecibo, setGerandoRecibo] = useState(false);

  const validarCPF = (cpf) => {
    if (!cpf) return true;
    const c = cpf.replace(/\D/g, '');
    if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(c[i]) * (10 - i);
    let r = 11 - (soma % 11);
    if ((r > 9 ? 0 : r) !== parseInt(c[9])) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(c[i]) * (11 - i);
    r = 11 - (soma % 11);
    return (r > 9 ? 0 : r) === parseInt(c[10]);
  };

  const validarCNPJ = (cnpj) => {
    if (!cnpj) return true;
    const c = cnpj.replace(/\D/g, '');
    if (c.length !== 14 || /^(\d)\1+$/.test(c)) return false;
    let tam = c.length - 2, num = c.substring(0, tam), dig = c.substring(tam);
    let soma = 0, pos = tam - 7;
    for (let i = tam; i >= 1; i--) { soma += num.charAt(tam - i) * pos--; if (pos < 2) pos = 9; }
    let res = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (res !== parseInt(dig[0])) return false;
    tam++; num = c.substring(0, tam); soma = 0; pos = tam - 7;
    for (let i = tam; i >= 1; i--) { soma += num.charAt(tam - i) * pos--; if (pos < 2) pos = 9; }
    res = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return res === parseInt(dig[1]);
  };

  const validarEmail = (email) => { if (!email) return true; return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); };
  const validarCEP = (cep) => { if (!cep) return true; return cep.replace(/\D/g, '').length === 8; };

  const formatarCPF = (cpf) => { if (!cpf) return ''; return cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'); };
  const formatarCNPJ = (cnpj) => { if (!cnpj) return ''; return cnpj.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'); };

  const formatarDocumentoCliente = (cliente) => {
    if (cliente.cpf && cliente.cpf.replace(/\D/g, '').length === 11) return `CPF: ${formatarCPF(cliente.cpf)}`;
    if (cliente.cnpj && cliente.cnpj.replace(/\D/g, '').length === 14) return `CNPJ: ${formatarCNPJ(cliente.cnpj)}`;
    if (cliente.cpfCnpj) {
      const n = cliente.cpfCnpj.replace(/\D/g, '');
      if (n.length === 11) return `CPF: ${formatarCPF(n)}`;
      if (n.length === 14) return `CNPJ: ${formatarCNPJ(n)}`;
    }
    return null;
  };

  const verificarCpfNaApi = async (cpf) => {
    if (!cpf || cpf.replace(/\D/g, '').length !== 11) return;
    if (!validarCPF(cpf)) { setCpfStatus('invalid'); setCpfMessage('CPF inválido'); setErrorsCliente(prev => ({...prev, cpf: 'CPF inválido'})); return; }
    setCpfStatus('checking'); setCpfMessage('Verificando CPF...');
    setErrorsCliente(prev => { const e = {...prev}; delete e.cpf; return e; });
    try {
      const response = await axios.get(`${API_BASE_URL}/clientes/cpf/${cpf.replace(/\D/g, '')}`, getAuthHeader());
      if (response.data) { setCpfStatus('duplicate'); setCpfMessage('CPF já cadastrado'); setErrorsCliente(prev => ({...prev, cpf: 'CPF já cadastrado'})); }
      else { setCpfStatus('valid'); setCpfMessage('CPF válido'); }
    } catch { setCpfStatus('valid'); setCpfMessage('CPF válido'); }
  };

  const verificarCnpjNaApi = async (cnpj) => {
    if (!cnpj || cnpj.replace(/\D/g, '').length !== 14) return;
    if (!validarCNPJ(cnpj)) { setCnpjStatus('invalid'); setCnpjMessage('CNPJ inválido'); setErrorsCliente(prev => ({...prev, cnpj: 'CNPJ inválido'})); return; }
    setCnpjStatus('checking'); setCnpjMessage('Verificando CNPJ...');
    setErrorsCliente(prev => { const e = {...prev}; delete e.cnpj; return e; });
    try {
      const response = await axios.get(`${API_BASE_URL}/clientes/cnpj/${cnpj.replace(/\D/g, '')}`, getAuthHeader());
      if (response.data) { setCnpjStatus('duplicate'); setCnpjMessage('CNPJ já cadastrado'); setErrorsCliente(prev => ({...prev, cnpj: 'CNPJ já cadastrado'})); }
      else { setCnpjStatus('valid'); setCnpjMessage('CNPJ válido'); }
    } catch { setCnpjStatus('valid'); setCnpjMessage('CNPJ válido'); }
  };

  const handleCpfChange = (e) => {
    const value = e.target.value;
    setNovoCliente({...novoCliente, cpf: value});
    const limpo = value.replace(/\D/g, '');
    if (limpo.length === 0) { setCpfStatus(null); setCpfMessage(''); return; }
    if (limpo.length === 11) setTimeout(() => verificarCpfNaApi(value), 800);
    else { setCpfStatus(null); setCpfMessage(''); }
  };

  const handleCnpjChange = (e) => {
    const value = e.target.value;
    setNovoCliente({...novoCliente, cnpj: value});
    const limpo = value.replace(/\D/g, '');
    if (limpo.length === 0) { setCnpjStatus(null); setCnpjMessage(''); return; }
    if (limpo.length === 14) setTimeout(() => verificarCnpjNaApi(value), 800);
    else { setCnpjStatus(null); setCnpjMessage(''); }
  };

  // Lupa do CNPJ no cadastro de novo cliente: só habilita com CNPJ completo, válido e ainda não cadastrado
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const podeConsultarCnpj = (novoCliente.cnpj || '').replace(/\D/g, '').length === 14
    && cnpjStatus === 'valid'
    && !loading
    && !buscandoCnpj;

  // Substitui nome, contato e endereço pelos do CNPJ consultado (inclusive limpando o que a
  // consulta não trouxe), para não sobrar dado de um CNPJ consultado antes.
  const preencherPorCnpj = async () => {
    if (!podeConsultarCnpj) return;
    setBuscandoCnpj(true);
    const { dados, erro } = await consultarCnpj(novoCliente.cnpj, API_BASE_URL, getAuthHeader());
    setBuscandoCnpj(false);

    if (!dados) {
      addToast('error', erro);
      return;
    }

    setNovoCliente(prev => {
      const novo = { ...prev };
      Object.keys(dados).forEach(campo => {
        novo[campo] = dados[campo] || '';
      });
      return novo;
    });
    const camposOpcionais = {
      email: 'e-mail', telefone: 'telefone', cep: 'CEP', logradouro: 'endereço', bairro: 'bairro', cidade: 'cidade',
    };
    const faltando = Object.keys(camposOpcionais).filter(campo => !dados[campo]).map(campo => camposOpcionais[campo]);
    if (faltando.length > 0) {
      addToast('warning', `Dados preenchidos pelo CNPJ. Não encontrei: ${faltando.join(', ')}. Preencha manualmente.`);
    } else {
      addToast('success', 'Dados preenchidos a partir do CNPJ.');
    }
  };

  const buscarEnderecoPorCEP = async (cep) => {
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) return;
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      if (response.data && !response.data.erro) {
        setNovoCliente(prev => ({ ...prev, logradouro: response.data.logradouro || '', bairro: response.data.bairro || '', cidade: response.data.localidade || '', uf: response.data.uf || '', complemento: response.data.complemento || prev.complemento }));
        addToast('success', 'Endereço encontrado!');
      } else addToast('warning', 'CEP não encontrado');
    } catch { addToast('error', 'Erro ao buscar CEP'); }
  };

  const validarFormularioCliente = () => {
    const newErrors = {};
    if (!novoCliente.nome || novoCliente.nome.trim().length < 3) newErrors.nome = 'Nome deve ter pelo menos 3 caracteres';
    if (novoCliente.email && !validarEmail(novoCliente.email)) newErrors.email = 'Email inválido';
    const cpfLimpo = (novoCliente.cpf || '').replace(/\D/g, '');
    const cnpjLimpo = (novoCliente.cnpj || '').replace(/\D/g, '');
    if (cpfLimpo === '' && cnpjLimpo === '') {
      newErrors.cpf = 'CPF ou CNPJ é obrigatório';
      newErrors.cnpj = 'CPF ou CNPJ é obrigatório';
    } else {
      if (cpfLimpo !== '') {
        if (!validarCPF(novoCliente.cpf)) newErrors.cpf = 'CPF inválido';
        else if (cpfStatus === 'duplicate') newErrors.cpf = 'CPF já cadastrado';
      }
      if (cnpjLimpo !== '') {
        if (!validarCNPJ(novoCliente.cnpj)) newErrors.cnpj = 'CNPJ inválido';
        else if (cnpjStatus === 'duplicate') newErrors.cnpj = 'CNPJ já cadastrado';
      }
    }
    // Endereço obrigatório (numero fica de fora - so front, backend segue aceitando em branco).
    if (!novoCliente.logradouro || novoCliente.logradouro.trim() === '') newErrors.logradouro = 'Logradouro é obrigatório';
    if (!novoCliente.bairro || novoCliente.bairro.trim() === '') newErrors.bairro = 'Bairro é obrigatório';
    if (!novoCliente.cidade || novoCliente.cidade.trim() === '') newErrors.cidade = 'Cidade é obrigatória';
    if (!novoCliente.uf || novoCliente.uf.trim() === '') newErrors.uf = 'Estado (UF) é obrigatório';
    if (!novoCliente.cep || novoCliente.cep.replace(/\D/g, '') === '') newErrors.cep = 'CEP é obrigatório';
    else if (!validarCEP(novoCliente.cep)) newErrors.cep = 'CEP inválido';
    setErrorsCliente(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getInputBorderStyle = (status, hasError) => {
    if (hasError) return { borderColor: '#e74c3c' };
    if (status === 'checking') return { borderColor: '#f39c12' };
    if (status === 'valid') return { borderColor: '#27ae60' };
    if (status === 'invalid' || status === 'duplicate') return { borderColor: '#e74c3c' };
    return {};
  };

  const formatarMoeda = (valor) => {
    if (valor === null || valor === undefined) return '0,00';
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(typeof valor === 'string' ? parseFloat(valor) : valor);
  };

  const getAuthHeader = () => ({ headers: { 'Authorization': `Bearer ${localStorage.getItem('jwtToken')}` } });

  const carregarOrdemExistente = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/ordemservico/${id}`, getAuthHeader());
      const ordem = response.data;
      setFormOrdem({ idOrdemServico: ordem.idOrdemServico, dataAbertura: ordem.dataAbertura?.split('T')[0] || new Date().toISOString().split('T')[0], observacoes: ordem.observacoes || '', valor: ordem.valor || 0 });
      setClienteSelecionado(ordem.cliente);
      if (ordem.observacoes) setMostrarObservacoes(true);
      const produtosTemp = [];
      if (ordem.ordemServicoProdutos?.length > 0) {
        ordem.ordemServicoProdutos.forEach((item, idx) => {
          const itemId = `${item.produtoView.idProduto}_${Date.now()}_${idx}_${Math.random()}`;
          produtosTemp.push({
            idProduto: item.produtoView.idProduto,
            itemId,
            nome: item.produtoView.nome.toUpperCase(),
            descricao: item.produtoView.descricao,
            preco: item.precoProduto,
            quantidade: item.quantidadeProduto,
            subtotal: item.precoProduto * item.quantidadeProduto,
            placa: item.placa || '',
            documento: item.documento || '',
          });
        });
      }
      setProdutosSelecionados(produtosTemp);
      carregarTodosProdutos();
    } catch { addToast('error', 'Erro ao carregar ordem de serviço'); }
    finally { setLoading(false); }
  };

  const carregarTodosProdutos = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/produtos/ordem`, getAuthHeader());
      const produtos = response.data.content || response.data || [];
      const produtosOrdenados = ordenarProdutosPorPrioridade(produtos);
      setTodosProdutos(produtosOrdenados);
      setModoListaCompleta(produtosOrdenados.length <= 100);
    } catch { setModoListaCompleta(false); }
    finally { setLoading(false); }
  };

  const buscarProdutos = async () => {
    setBuscandoProduto(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/produtos/ordem/nome/${termoPesquisaProduto}`, getAuthHeader());
      setResultadosPesquisaProduto(ordenarProdutosPorPrioridade(response.data?.length > 0 ? response.data : []));
    } catch { setResultadosPesquisaProduto([]); }
    finally { setBuscandoProduto(false); }
  };

  const buscarClientes = async () => {
    if (!termoPesquisaCliente || termoPesquisaCliente.trim().length < 2) return;
    setBuscandoCliente(true);
    try {
      const termo = termoPesquisaCliente.trim();
      const apenasNumeros = termo.replace(/\D/g, '');
      let url;
      if (apenasNumeros.length === 11) url = `${API_BASE_URL}/clientes/cpf/${apenasNumeros}`;
      else if (apenasNumeros.length === 14) url = `${API_BASE_URL}/clientes/cnpj/${apenasNumeros}`;
      else url = `${API_BASE_URL}/clientes/nome/${termo}/pagina?page=0&size=20`;
      const response = await axios.get(url, getAuthHeader());
      let lista = [];
      if (Array.isArray(response.data)) lista = response.data;
      else if (response.data?.content) lista = response.data.content;
      else if (response.data?.idCliente) lista = [response.data];
      if (lista.length > 0) { setResultadosPesquisaCliente(lista); setMostrarBotaoCadastroCliente(false); }
      else { setResultadosPesquisaCliente([]); setMostrarBotaoCadastroCliente(true); }
    } catch { setResultadosPesquisaCliente([]); setMostrarBotaoCadastroCliente(true); }
    finally { setBuscandoCliente(false); }
  };

  const cadastrarCliente = async () => {
    if (!validarFormularioCliente()) { addToast('warning', 'Corrija os erros antes de salvar'); return; }
    setCadastrandoCliente(true);
    try {
      const clienteData = { nome: novoCliente.nome, identidade: novoCliente.identidade || null, cpf: novoCliente.cpf || null, cnpj: novoCliente.cnpj || null, telefone: novoCliente.telefone || null, email: novoCliente.email || null, logradouro: novoCliente.logradouro || null, numero: novoCliente.numero || null, bairro: novoCliente.bairro || null, complemento: novoCliente.complemento || null, cep: novoCliente.cep || null, cidade: novoCliente.cidade || null, uf: novoCliente.uf || null, ativo: true };
      const response = await axios.post(`${API_BASE_URL}/clientes`, clienteData, getAuthHeader());
      setClienteSelecionado(response.data);
      addToast('success', 'Cliente cadastrado!');
      setModalCadastroClienteAberto(false);
      setModalPesquisaClienteAberto(false);
      resetFormCadastroCliente();
      carregarTodosProdutos();
    } catch { addToast('error', 'Erro ao cadastrar cliente'); }
    finally { setCadastrandoCliente(false); }
  };

  const resetFormCadastroCliente = () => { setNovoCliente(formClienteVazio()); setErrorsCliente({}); setCpfStatus(null); setCnpjStatus(null); setCpfMessage(''); setCnpjMessage(''); setCamposDoPrintCadastro([]); setCepDoPrintCadastro(''); };

  // Print colado (Ctrl+V) com os dados do cliente: sobrescreve os campos lidos e destaca os que mudaram. Nada é salvo sozinho.
  const aplicarPrintCadastro = (dados, alterados) => {
    setNovoCliente(prev => ({ ...prev, ...dados }));
    setCamposDoPrintCadastro(prev => [...new Set([...prev, ...alterados])]);
    if (dados.cep) setCepDoPrintCadastro(dados.cep);
    setErrorsCliente(prev => { const e = { ...prev }; Object.keys(dados).forEach(campo => delete e[campo]); return e; });
    if (dados.cpf) verificarCpfNaApi(dados.cpf);
    if (dados.cnpj) verificarCnpjNaApi(dados.cnpj);
  };

  const aplicarPrintEdicao = (dados, alterados) => {
    setFormEdicao(prev => ({ ...prev, ...dados }));
    setCamposDoPrintEdicao(prev => [...new Set([...prev, ...alterados])]);
    if (dados.cep) setCepDoPrintEdicao(dados.cep);
    setErrorsEdicao(prev => { const e = { ...prev }; Object.keys(dados).forEach(campo => delete e[campo]); return e; });
    if (dados.cpf) verificarCpfNaApiEdicao(dados.cpf);
    if (dados.cnpj) verificarCnpjNaApiEdicao(dados.cnpj);
  };

  const destaquePrintCadastro = (campo) => (camposDoPrintCadastro.includes(campo) ? ESTILO_CAMPO_DO_PRINT : {});
  const destaquePrintEdicao = (campo) => (camposDoPrintEdicao.includes(campo) ? ESTILO_CAMPO_DO_PRINT : {});

  const verificarCpfNaApiEdicao = async (cpf) => {
    if (!cpf || cpf.replace(/\D/g, '').length !== 11) return;
    if (!validarCPF(cpf)) { setCpfStatusEdicao('invalid'); setCpfMessageEdicao('CPF inválido'); setErrorsEdicao(prev => ({...prev, cpf: 'CPF inválido'})); return; }
    setCpfStatusEdicao('checking'); setCpfMessageEdicao('Verificando CPF...');
    setErrorsEdicao(prev => { const e = {...prev}; delete e.cpf; return e; });
    try {
      const response = await axios.get(`${API_BASE_URL}/clientes/cpf/${cpf.replace(/\D/g, '')}`, getAuthHeader());
      if (response.data && response.data.idCliente !== clienteEditando?.idCliente) {
        setCpfStatusEdicao('duplicate'); setCpfMessageEdicao('CPF já cadastrado'); setErrorsEdicao(prev => ({...prev, cpf: 'CPF já cadastrado'}));
      } else { setCpfStatusEdicao('valid'); setCpfMessageEdicao('CPF válido'); }
    } catch { setCpfStatusEdicao('valid'); setCpfMessageEdicao('CPF válido'); }
  };

  const verificarCnpjNaApiEdicao = async (cnpj) => {
    if (!cnpj || cnpj.replace(/\D/g, '').length !== 14) return;
    if (!validarCNPJ(cnpj)) { setCnpjStatusEdicao('invalid'); setCnpjMessageEdicao('CNPJ inválido'); setErrorsEdicao(prev => ({...prev, cnpj: 'CNPJ inválido'})); return; }
    setCnpjStatusEdicao('checking'); setCnpjMessageEdicao('Verificando CNPJ...');
    setErrorsEdicao(prev => { const e = {...prev}; delete e.cnpj; return e; });
    try {
      const response = await axios.get(`${API_BASE_URL}/clientes/cnpj/${cnpj.replace(/\D/g, '')}`, getAuthHeader());
      if (response.data && response.data.idCliente !== clienteEditando?.idCliente) {
        setCnpjStatusEdicao('duplicate'); setCnpjMessageEdicao('CNPJ já cadastrado'); setErrorsEdicao(prev => ({...prev, cnpj: 'CNPJ já cadastrado'}));
      } else { setCnpjStatusEdicao('valid'); setCnpjMessageEdicao('CNPJ válido'); }
    } catch { setCnpjStatusEdicao('valid'); setCnpjMessageEdicao('CNPJ válido'); }
  };

  const handleCpfChangeEdicao = (e) => {
    const value = e.target.value;
    setFormEdicao(prev => ({...prev, cpf: value}));
    const limpo = value.replace(/\D/g, '');
    if (limpo.length === 0) { setCpfStatusEdicao(null); setCpfMessageEdicao(''); return; }
    if (limpo.length === 11) setTimeout(() => verificarCpfNaApiEdicao(value), 800);
    else { setCpfStatusEdicao(null); setCpfMessageEdicao(''); }
  };

  const handleCnpjChangeEdicao = (e) => {
    const value = e.target.value;
    setFormEdicao(prev => ({...prev, cnpj: value}));
    const limpo = value.replace(/\D/g, '');
    if (limpo.length === 0) { setCnpjStatusEdicao(null); setCnpjMessageEdicao(''); return; }
    if (limpo.length === 14) setTimeout(() => verificarCnpjNaApiEdicao(value), 800);
    else { setCnpjStatusEdicao(null); setCnpjMessageEdicao(''); }
  };

  // Lupa do CNPJ na edição do cliente: completa só os campos em branco (cadastro antigo/incompleto),
  // sem trocar o que já está preenchido
  const [buscandoCnpjEdicao, setBuscandoCnpjEdicao] = useState(false);
  const podeConsultarCnpjEdicao = (formEdicao.cnpj || '').replace(/\D/g, '').length === 14
    && cnpjStatusEdicao === 'valid'
    && !salvandoEdicao
    && !buscandoCnpjEdicao;

  const preencherPorCnpjEdicao = async () => {
    if (!podeConsultarCnpjEdicao) return;
    setBuscandoCnpjEdicao(true);
    const { dados, erro } = await consultarCnpj(formEdicao.cnpj, API_BASE_URL, getAuthHeader());
    setBuscandoCnpjEdicao(false);
    if (!dados) { addToast('error', erro); return; }
    const { novo, completados } = completarComDadosCnpj(formEdicao, dados);
    setFormEdicao(novo);
    const aviso = avisoCompletarCnpj(completados);
    addToast(aviso.tipo, aviso.texto);
  };

  const buscarEnderecoPorCEPEdicao = async (cep) => {
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) return;
    setLoadingCepEdicao(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      if (response.data && !response.data.erro) {
        setFormEdicao(prev => ({ ...prev, logradouro: response.data.logradouro || prev.logradouro, bairro: response.data.bairro || prev.bairro, cidade: response.data.localidade || prev.cidade, uf: response.data.uf || prev.uf, complemento: response.data.complemento || prev.complemento }));
        addToast('success', 'Endereço encontrado!');
      } else addToast('warning', 'CEP não encontrado');
    } catch { addToast('error', 'Erro ao buscar CEP'); }
    finally { setLoadingCepEdicao(false); }
  };

  const validarFormularioEdicao = () => {
    const newErrors = {};
    if (!formEdicao.nome || formEdicao.nome.trim().length < 3) newErrors.nome = 'Nome deve ter pelo menos 3 caracteres';
    if (formEdicao.email && !validarEmail(formEdicao.email)) newErrors.email = 'Email inválido';
    const cpfLimpo = (formEdicao.cpf || '').replace(/\D/g, '');
    const cnpjLimpo = (formEdicao.cnpj || '').replace(/\D/g, '');
    if (cpfLimpo === '' && cnpjLimpo === '') {
      newErrors.cpf = 'CPF ou CNPJ é obrigatório';
      newErrors.cnpj = 'CPF ou CNPJ é obrigatório';
    } else {
      if (cpfLimpo !== '') {
        if (!validarCPF(formEdicao.cpf)) newErrors.cpf = 'CPF inválido';
        else if (cpfStatusEdicao === 'duplicate') newErrors.cpf = 'CPF já cadastrado';
      }
      if (cnpjLimpo !== '') {
        if (!validarCNPJ(formEdicao.cnpj)) newErrors.cnpj = 'CNPJ inválido';
        else if (cnpjStatusEdicao === 'duplicate') newErrors.cnpj = 'CNPJ já cadastrado';
      }
    }
    // Endereço obrigatório (numero fica de fora - so front, backend segue aceitando em branco).
    if (!formEdicao.logradouro || formEdicao.logradouro.trim() === '') newErrors.logradouro = 'Logradouro é obrigatório';
    if (!formEdicao.bairro || formEdicao.bairro.trim() === '') newErrors.bairro = 'Bairro é obrigatório';
    if (!formEdicao.cidade || formEdicao.cidade.trim() === '') newErrors.cidade = 'Cidade é obrigatória';
    if (!formEdicao.uf || formEdicao.uf.trim() === '') newErrors.uf = 'Estado (UF) é obrigatório';
    if (!formEdicao.cep || formEdicao.cep.replace(/\D/g, '') === '') newErrors.cep = 'CEP é obrigatório';
    else if (!validarCEP(formEdicao.cep)) newErrors.cep = 'CEP inválido';
    setErrorsEdicao(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetFormEdicao = () => {
    setFormEdicao(formClienteVazio());
    setErrorsEdicao({});
    setCamposDoPrintEdicao([]);
    setCepDoPrintEdicao('');
    setCpfStatusEdicao(null);
    setCnpjStatusEdicao(null);
    setCpfMessageEdicao('');
    setCnpjMessageEdicao('');
    setClienteEditando(null);
  };

  const abrirModalEdicaoCliente = async (cliente) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/clientes/${cliente.idCliente}`, getAuthHeader());
      const dados = response.data;
      setClienteEditando(dados);
      setFormEdicao({
        nome: dados.nome || '',
        identidade: dados.identidade || '',
        cpf: dados.cpf || '',
        cnpj: dados.cnpj || '',
        telefone: dados.telefone || '',
        email: dados.email || '',
        logradouro: dados.logradouro || '',
        numero: dados.numero || '',
        bairro: dados.bairro || '',
        complemento: dados.complemento || '',
        cep: dados.cep || '',
        cidade: dados.cidade || '',
        uf: dados.uf || '',
      });
      setErrorsEdicao({});
      setCamposDoPrintEdicao([]);
      setCepDoPrintEdicao('');
      if (dados.cpf) { setCpfStatusEdicao('valid'); setCpfMessageEdicao('CPF já cadastrado'); } else { setCpfStatusEdicao(null); setCpfMessageEdicao(''); }
      if (dados.cnpj) { setCnpjStatusEdicao('valid'); setCnpjMessageEdicao('CNPJ já cadastrado'); } else { setCnpjStatusEdicao(null); setCnpjMessageEdicao(''); }
      setModalEdicaoClienteAberto(true);
    } catch {
      addToast('error', 'Erro ao carregar dados do cliente');
    } finally {
      setLoading(false);
    }
  };

  const fecharModalEdicaoCliente = () => { setModalEdicaoClienteAberto(false); resetFormEdicao(); };

  const salvarEdicaoCliente = async () => {
    if (!validarFormularioEdicao()) { addToast('warning', 'Corrija os erros antes de salvar'); return; }
    setSalvandoEdicao(true);
    try {
      const clienteData = { nome: formEdicao.nome, identidade: formEdicao.identidade || null, cpf: formEdicao.cpf || null, cnpj: formEdicao.cnpj || null, telefone: formEdicao.telefone || null, email: formEdicao.email || null, logradouro: formEdicao.logradouro || null, numero: formEdicao.numero || null, bairro: formEdicao.bairro || null, complemento: formEdicao.complemento || null, cep: formEdicao.cep || null, cidade: formEdicao.cidade || null, uf: formEdicao.uf || null };
      const response = await axios.put(`${API_BASE_URL}/clientes/${clienteEditando.idCliente}`, clienteData, getAuthHeader());
      const clienteAtualizado = response.data && Object.keys(response.data).length > 0 ? response.data : { ...clienteEditando, ...clienteData };

      addToast('success', 'Cliente atualizado com sucesso!');

      setResultadosPesquisaCliente(prev => prev.map(c => c.idCliente === clienteAtualizado.idCliente ? { ...c, ...clienteAtualizado } : c));

      if (clienteSelecionado?.idCliente === clienteAtualizado.idCliente) setClienteSelecionado(clienteAtualizado);

      fecharModalEdicaoCliente();
    } catch (err) {
      addToast('error', 'Erro ao atualizar cliente: ' + (err.response?.data?.message || err.message));
    } finally {
      setSalvandoEdicao(false);
    }
  };

  // Dados do tomador que a NFS-e exige além do CPF/CNPJ (o número já é tratado na emissão).
  // Conferido ao selecionar o cliente, para não descobrir a falta só quando a nota for rejeitada.
  const camposObrigatoriosNfse = { nome: 'nome', logradouro: 'logradouro', bairro: 'bairro' };
  const camposFaltandoNfse = (cliente) => Object.keys(camposObrigatoriosNfse)
    .filter(campo => !String(cliente?.[campo] ?? '').trim())
    .map(campo => camposObrigatoriosNfse[campo]);

  const selecionarCliente = async (cliente) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/clientes/${cliente.idCliente}`, getAuthHeader());
      const faltando = camposFaltandoNfse(response.data);
      if (faltando.length > 0) {
        // Não avança: avisa o que falta e abre a edição do cliente; depois de salvar, é só selecionar de novo
        addToast('warning', `Cliente sem ${faltando.join(', ')} cadastrado. Complete o cadastro para criar a O.S.`);
        setLoading(false);
        abrirModalEdicaoCliente(cliente);
        return;
      }
      setClienteSelecionado(response.data);
      setModalPesquisaClienteAberto(false);
      setTermoPesquisaCliente('');
      setResultadosPesquisaCliente([]);
      setMostrarBotaoCadastroCliente(false);
      carregarTodosProdutos();
    } catch { addToast('error', 'Erro ao carregar cliente'); }
    finally { setLoading(false); }
  };

  const criarItemProduto = (produto) => ({
    idProduto: produto.idProduto,
    nome: produto.nome.toUpperCase(),
    itemId: `${produto.idProduto}_${Date.now()}_${Math.random()}`,
    descricao: produto.descricao,
    preco: produto.preco,
    quantidade: 1,
    subtotal: produto.preco,
    placa: '',
    documento: '',
  });

  // Lista completa filtrada pelo que foi digitado: todas as palavras no nome, sem diferenciar acento/maiúscula
  const semAcento = (texto) => String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const palavrasFiltro = semAcento(filtroProdutos).split(/\s+/).filter(Boolean);
  const produtosFiltrados = palavrasFiltro.length === 0
    ? todosProdutos
    : todosProdutos.filter(produto => palavrasFiltro.every(p => semAcento(produto.nome).includes(p)));

  const adicionarProduto = (produto) => {
    setProdutosSelecionados(prev => [...prev, criarItemProduto(produto)]);
  };

  const adicionarCampoPlaca = (itemId) => {
    const origem = produtosSelecionados.find(p => p.itemId === itemId);
    if (!origem) return;
    const novoItem = criarItemProduto({ idProduto: origem.idProduto, nome: origem.nome, descricao: origem.descricao, preco: origem.preco });
    setProdutosSelecionados(prev => {
      const idx = prev.findIndex(p => p.itemId === itemId);
      const copia = [...prev];
      copia.splice(idx + 1, 0, novoItem);
      return copia;
    });
  };

  const atualizarPlaca = (itemId, placa) => setProdutosSelecionados(prev => prev.map(p => p.itemId === itemId ? { ...p, placa: placa.toUpperCase() } : p));
  const atualizarDocumento = (itemId, documento) => setProdutosSelecionados(prev => prev.map(p => p.itemId === itemId ? { ...p, documento: documento.toUpperCase() } : p));
  const removerProduto = (itemId) => setProdutosSelecionados(prev => prev.filter(p => p.itemId !== itemId));
  const incrementarQuantidade = (itemId) => setProdutosSelecionados(prev => prev.map(p => { if (p.itemId !== itemId) return p; const atual = parseInt(p.quantidade, 10) || 0; const q = atual + 1; return { ...p, quantidade: q, subtotal: p.preco * q }; }));
  const decrementarQuantidade = (itemId) => setProdutosSelecionados(prev => prev.map(p => { if (p.itemId !== itemId) return p; const atual = parseInt(p.quantidade, 10) || 0; const q = Math.max(1, atual - 1); return { ...p, quantidade: q, subtotal: p.preco * q }; }));

  // ── NOVO: permite digitar a quantidade diretamente pelo teclado ──────────
  // Enquanto o usuário digita, aceitamos string vazia ou números parciais sem
  // forçar o valor mínimo (senão não dá pra apagar o número pra escrever outro).
  // A validação final (mínimo 1) acontece no blur, em finalizarEdicaoQuantidade.
  const atualizarQuantidade = (itemId, valorDigitado) => {
    const somenteNumeros = valorDigitado.replace(/\D/g, '');
    setProdutosSelecionados(prev => prev.map(p => {
      if (p.itemId !== itemId) return p;
      if (somenteNumeros === '') return { ...p, quantidade: '', subtotal: 0 };
      const q = parseInt(somenteNumeros, 10);
      return { ...p, quantidade: q, subtotal: p.preco * q };
    }));
  };

  const finalizarEdicaoQuantidade = (itemId) => {
    setProdutosSelecionados(prev => prev.map(p => {
      if (p.itemId !== itemId) return p;
      const atual = parseInt(p.quantidade, 10);
      const q = (!atual || atual < 1) ? 1 : atual;
      return { ...p, quantidade: q, subtotal: p.preco * q };
    }));
  };

  const calcularValorTotal = () => {
    const token = localStorage.getItem("jwtToken");
    const userData = decodeToken(token);
    setIssqn(userData?.empresaIssqn);
    let valorTotal = produtosSelecionados.reduce((total, produto) => total + (produto.subtotal || 0), 0);
    if (produtosSelecionados.length > 0) valorTotal += valorTotal * (issqn / 100);
    return valorTotal;
  };

  useEffect(() => { const total = calcularValorTotal(); setFormOrdem(prev => ({ ...prev, valor: total })); }, [produtosSelecionados]);
  useEffect(() => { const delay = setTimeout(() => { if (termoPesquisaCliente.length >= 2) buscarClientes(); else { setResultadosPesquisaCliente([]); setMostrarBotaoCadastroCliente(false); } }, 500); return () => clearTimeout(delay); }, [termoPesquisaCliente]);
  useEffect(() => { if (!modoListaCompleta) { const delay = setTimeout(() => { if (termoPesquisaProduto.length >= 2) buscarProdutos(); else setResultadosPesquisaProduto([]); }, 500); return () => clearTimeout(delay); } }, [termoPesquisaProduto, modoListaCompleta]);
  useEffect(() => { if (id) carregarOrdemExistente(); }, [id]);

  const validateOrdem = () => {
    const newErrors = {};
    if (!clienteSelecionado?.idCliente) newErrors.cliente = 'Cliente é obrigatório';
    if (produtosSelecionados.length === 0) newErrors.produtos = 'Pelo menos um produto é obrigatório';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const prepararDadosOrdem = () => {
    const produtosDTO = produtosSelecionados.map(p => ({
      produto: { idProduto: p.idProduto },
      precoProduto: p.preco,
      quantidadeProduto: parseInt(p.quantidade, 10) || 1,
      placa: p.placa || null,
      documento: p.documento || null,
    }));
    return { cliente: { idCliente: clienteSelecionado.idCliente }, observacoes: formOrdem.observacoes || "", ordemServicoProdutos: produtosDTO };
  };

  // ── CORREÇÃO: ao salvar com sucesso, não navega mais direto para a listagem.
  // Em vez disso, guarda o id da ordem salva e abre o modal de sucesso, que
  // oferece: Fechar (aí sim navega), Ver/Imprimir (abre o PDF em nova aba),
  // Gerar Novo Protocolo de Atendimento (abre a rota do protocolo levando o
  // nome do cliente via location.state) e Nova Ordem de Serviço (reseta o
  // formulário e permanece nesta tela pronta para lançar outra ordem). ──
  const salvarOrdemServico = async () => {
    if (!validateOrdem()) { addToast('warning', 'Preencha todos os campos obrigatórios'); return; }
    setLoading(true);
    try {
      const dadosOrdem = prepararDadosOrdem();
      let idSalvo = formOrdem.idOrdemServico;
      if (formOrdem.idOrdemServico) {
        await axios.put(`${API_BASE_URL}/ordemservico/${formOrdem.idOrdemServico}`, dadosOrdem, getAuthHeader());
        addToast('success', 'Ordem atualizada!');
      } else {
        const response = await axios.post(`${API_BASE_URL}/ordemservico`, dadosOrdem, getAuthHeader());
        idSalvo = response.data?.idOrdemServico || response.data?.id;
        addToast('success', 'Ordem criada!');
      }
      setIdOrdemSalva(idSalvo);
      setModalSucessoAberto(true);
    } catch (error) {
      addToast('error', `Erro ao salvar: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const fecharModalSucesso = () => {
    setModalSucessoAberto(false);
    setIdOrdemSalva(null);
    navigate('/ordemServico');
  };

  const verImprimirOrdem = async () => {
    if (!idOrdemSalva) return;
    setGerandoRecibo(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/ordemservico/recibo/${idOrdemSalva}`, { ...getAuthHeader(), responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, '_blank');
      if (!newWindow) {
        const link = document.createElement('a');
        link.href = url;
        link.download = `ordem-servico-${idOrdemSalva}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) {
      addToast('error', 'Erro ao abrir PDF: ' + error.message);
    } finally {
      setGerandoRecibo(false);
    }
  };

  const gerarNovoProtocolo = () => {
    const nomeCliente = clienteSelecionado?.nome || '';
    window.open(`/protocoloAtendimento?cliente=${encodeURIComponent(nomeCliente)}`, '_blank');
  };

  const resetFormOrdem = () => { setFormOrdem({ idOrdemServico: null, dataAbertura: new Date().toISOString().split('T')[0], observacoes: '', valor: 0 }); setClienteSelecionado(null); setProdutosSelecionados([]); setTodosProdutos([]); setErrors({}); setMostrarObservacoes(false); };

  // ── NOVO: botão "Nova Ordem de Serviço" do modal de sucesso.
  // Fecha o modal, limpa todo o formulário (cliente, produtos, observações)
  // e garante que a URL fique sem :id (rota de criação), permitindo lançar
  // a próxima ordem sem sair da tela. ──
  const novaOrdemServicoAposSalvar = () => {
    setModalSucessoAberto(false);
    setIdOrdemSalva(null);
    resetFormOrdem();
    navigate('/criar-editar-ordemServico');
  };

  const getBuscaHint = () => {
    const nums = termoPesquisaCliente.replace(/\D/g, '');
    if (nums.length === 11) return { text: 'Buscando por CPF', color: '#27ae60' };
    if (nums.length === 14) return { text: 'Buscando por CNPJ', color: '#3498db' };
    if (termoPesquisaCliente.length >= 2) return { text: 'Buscando por nome', color: '#7f8c8d' };
    return { text: 'Digite nome, CPF ou CNPJ para buscar', color: '#bdc3c7' };
  };

  return (
    <div style={s.page} className="ordem-servico-page">
      <Header />
      <div style={s.wrap} className="ordem-servico-wrap">

        {/* ── Cabeçalho ── */}
        <div style={s.pageHeader}>
          <div style={s.pageHeaderLeft}>
            <FaClipboardList style={s.pageHeaderIcon} />
            <div>
              <h1 style={s.pageTitle}>{formOrdem.idOrdemServico ? `OS #${formOrdem.idOrdemServico}` : 'Nova Ordem de Serviço'}</h1>
              <p style={s.pageSubtitle}>Selecione o cliente e adicione os serviços</p>
            </div>
          </div>
        </div>

        {/* ── Cliente ── */}
        <div style={s.card}>
          <div style={s.cardHeader}>
            <FaUser size={14} style={{ color: '#008080' }} />
            <span style={s.cardTitle}>Cliente</span>
          </div>
          {clienteSelecionado ? (
            <div style={s.clienteRow}>
              <div style={s.clienteAvatar}>{(clienteSelecionado.nome || '?')[0].toUpperCase()}</div>
              <div style={s.clienteInfo}>
                <span style={s.clienteNome}>{clienteSelecionado.nome}</span>
                <div style={s.clienteMeta}>
                  {clienteSelecionado.telefone && <span><FaPhone size={10} /> {clienteSelecionado.telefone}</span>}
                  {clienteSelecionado.email && <span><FaEnvelope size={10} /> {clienteSelecionado.email}</span>}
                </div>
              </div>
              <button onClick={() => setModalPesquisaClienteAberto(true)} style={s.btnOutline} disabled={loading}>
                <FaEdit size={11} /> Alterar
              </button>
            </div>
          ) : (
            <div>
              <button onClick={() => setModalPesquisaClienteAberto(true)} style={s.btnPrimary} disabled={loading}>
                <FaSearch size={12} /> Buscar Cliente
              </button>
              {errors.cliente && <span style={s.errorText}>{errors.cliente}</span>}
            </div>
          )}
        </div>

        {/* ── Produtos ── */}
        {clienteSelecionado && (
          <div style={s.produtosGrid} className="ordem-servico-grid">

            {/* ── Painel Selecionados ── */}
            <div style={s.painelCard} className="ordem-servico-painel">
              <div style={s.cardHeader}>
                <FaCheck size={13} style={{ color: '#27ae60' }} />
                <span style={s.cardTitle}>Selecionados ({produtosSelecionados.length})</span>
                {errors.produtos && <span style={{ ...s.errorText, marginLeft: 'auto' }}>{errors.produtos}</span>}
              </div>

              {produtosSelecionados.length === 0 ? (
                <div style={s.emptyState}>
                  <FaBox size={28} style={{ color: '#ddd', marginBottom: 8 }} />
                  <p style={{ margin: 0, color: '#aaa', fontSize: 13 }}>Nenhum produto selecionado</p>
                  <p style={{ margin: 0, color: '#ccc', fontSize: 11 }}>Clique nos itens à direita para adicionar</p>
                </div>
              ) : (
                <div style={s.selecionadosList}>
                  {produtosSelecionados.map((produto) => (
                    <div key={produto.itemId} style={s.selecionadoCard}>
                      <div style={s.selecionadoHeader}>
                        <div style={{ flex: 1 }}>
                          <span style={s.selecionadoNome}>{produto.nome}</span>
                          {produto.descricao && <span style={s.selecionadoDesc}>{produto.descricao}</span>}
                        </div>
                        <div style={s.selecionadoAcoes}>
                          <div style={s.qtdControle}>
                            <button onClick={() => decrementarQuantidade(produto.itemId)} style={s.qtdBtn}><FaMinus size={8} /></button>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={produto.quantidade}
                              onChange={(e) => atualizarQuantidade(produto.itemId, e.target.value)}
                              onBlur={() => finalizarEdicaoQuantidade(produto.itemId)}
                              onFocus={(e) => e.target.select()}
                              style={s.qtdInput}
                            />
                            <button onClick={() => incrementarQuantidade(produto.itemId)} style={s.qtdBtn}><FaPlus size={8} /></button>
                          </div>
                          <span style={s.subtotal}>R$ {formatarMoeda(produto.subtotal)}</span>
                          <button onClick={() => removerProduto(produto.itemId)} style={s.btnRemove}><FaTrash size={11} /></button>
                        </div>
                      </div>
                      <div style={s.placaRow}>
                        <input type="text" value={produto.placa} onChange={(e) => atualizarPlaca(produto.itemId, e.target.value)} placeholder="Placa" style={s.inputPlaca} disabled={loading} />
                        <input type="text" value={produto.documento} onChange={(e) => atualizarDocumento(produto.itemId, e.target.value)} placeholder="Documento" style={s.inputDoc} disabled={loading} />
                      </div>
                      <button onClick={() => adicionarCampoPlaca(produto.itemId)} style={s.btnAddPlaca}><FaPlus size={9} /> Adicionar placa</button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* ── Painel Disponíveis ── */}
            <div style={s.painelCard} className="ordem-servico-painel">
              <div style={s.cardHeader}>
                <FaBoxes size={13} style={{ color: '#3498db' }} />
                <span style={s.cardTitle}>Produtos Disponíveis</span>
                <span style={s.cardHint}>duplo clique para adicionar</span>
              </div>

              {modoListaCompleta ? (
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                  {/* Filtro: escreve parte do nome e a lista mostra só os que batem (sem diferenciar acento/maiúscula) */}
                  <div style={s.filtroBox}>
                    <FaSearch style={s.filtroIcone} />
                    <input
                      type="text"
                      value={filtroProdutos}
                      onChange={(e) => setFiltroProdutos(e.target.value)}
                      placeholder="Filtrar serviço..."
                      style={s.filtroInput}
                    />
                    {filtroProdutos && (
                      <button type="button" onClick={() => setFiltroProdutos('')} style={s.filtroLimpar} title="Limpar filtro">
                        <FaTimes size={11} />
                      </button>
                    )}
                  </div>
                  <div style={s.disponivelList}>
                    {produtosFiltrados.map(produto => (
                      <div key={produto.idProduto} style={s.disponivelItem} onDoubleClick={() => adicionarProduto(produto)}>
                        <span style={s.disponivelNome}>{produto.nome.toUpperCase()}</span>
                        <span style={s.disponivelPreco}>R$ {formatarMoeda(produto.preco)}</span>
                      </div>
                    ))}
                    {todosProdutos.length === 0 && <p style={{ textAlign: 'center', color: '#aaa', fontSize: 13, padding: 16 }}>Nenhum produto cadastrado</p>}
                    {todosProdutos.length > 0 && produtosFiltrados.length === 0 && (
                      <p style={{ textAlign: 'center', color: '#aaa', fontSize: 13, padding: 16 }}>Nenhum serviço encontrado para "{filtroProdutos}"</p>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                  <input type="text" value={termoPesquisaProduto} onChange={(e) => setTermoPesquisaProduto(e.target.value)} placeholder="Buscar produto..." style={{ ...s.searchInput, marginBottom: 8 }} />
                  <div style={s.disponivelList}>
                    {buscandoProduto ? <p style={{ textAlign: 'center', color: '#aaa', fontSize: 13, padding: 16 }}>Buscando...</p>
                      : resultadosPesquisaProduto.length > 0 ? resultadosPesquisaProduto.map(produto => (
                        <div key={produto.idProduto} style={s.disponivelItem} onDoubleClick={() => adicionarProduto(produto)}>
                          <span style={s.disponivelNome}>{produto.nome.toUpperCase()}</span>
                          <span style={s.disponivelPreco}>R$ {formatarMoeda(produto.preco)}</span>
                        </div>
                      ))
                      : <p style={{ textAlign: 'center', color: '#aaa', fontSize: 13, padding: 16 }}>{termoPesquisaProduto.length >= 2 ? 'Nenhum produto encontrado' : 'Digite para buscar'}</p>
                    }
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── Observações ── */}
        {clienteSelecionado && (
          <div style={s.card}>
            <button onClick={() => setMostrarObservacoes(!mostrarObservacoes)} style={s.obsToggle}>
              <FaStickyNote size={13} style={{ color: mostrarObservacoes ? '#008080' : '#aaa' }} />
              <span style={{ color: mostrarObservacoes ? '#008080' : '#666', fontWeight: 600, fontSize: 13 }}>
                {mostrarObservacoes ? 'Observações' : 'Adicionar observações'}
              </span>
              {mostrarObservacoes ? <FaChevronUp size={11} style={{ color: '#aaa', marginLeft: 'auto' }} /> : <FaChevronDown size={11} style={{ color: '#aaa', marginLeft: 'auto' }} />}
            </button>
            {mostrarObservacoes && (
              <textarea
                value={formOrdem.observacoes}
                onChange={(e) => setFormOrdem({ ...formOrdem, observacoes: e.target.value })}
                placeholder="Informações adicionais sobre a ordem de serviço..."
                rows="3"
                style={s.obsTextarea}
              />
            )}
          </div>
        )}

        {/* ── Rodapé ── */}
        {clienteSelecionado && (
          <div style={s.footer}>
            <div style={s.footerLeft}>
              <button onClick={resetFormOrdem} style={s.btnSecondary} disabled={loading}><FaArrowLeft size={12} /> Limpar</button>
              <button onClick={salvarOrdemServico} style={s.btnPrimary} disabled={loading}><FaSave size={12} /> {loading ? 'Salvando...' : 'Salvar Ordem de Serviço'}</button>
            </div>
            <div style={s.footerRight}>
              <div style={s.issqnBadge}>
                <FaCalculator size={16} style={{ color: '#f39c12' }} />
                <div>
                  <span style={s.badgeLabel}>ISSQN</span>
                  <span style={s.issqnValue}>+ {issqn}%</span>
                </div>
              </div>
              <div style={s.totalBadge}>
                <FaMoneyBillWave size={18} style={{ color: '#27ae60' }} />
                <div>
                  <span style={s.badgeLabel}>VALOR TOTAL</span>
                  <span style={s.totalValue}>R$ {formatarMoeda(formOrdem.valor)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ── Modal Pesquisa Cliente ── */}
      {modalPesquisaClienteAberto && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}>
              <span style={s.modalTitle}><FaSearch size={14} /> Buscar Cliente</span>
              <button onClick={() => { setModalPesquisaClienteAberto(false); setTermoPesquisaCliente(''); setResultadosPesquisaCliente([]); setMostrarBotaoCadastroCliente(false); }} style={s.modalClose}>&times;</button>
            </div>
            <div style={s.modalBody}>
              <input type="text" value={termoPesquisaCliente} onChange={(e) => setTermoPesquisaCliente(e.target.value)} placeholder="Nome, CPF ou CNPJ..." style={s.searchInput} autoFocus />
              <p style={{ fontSize: 11, color: getBuscaHint().color, margin: '4px 0 12px', fontWeight: 500 }}>{getBuscaHint().text}</p>
              {buscandoCliente ? <p style={s.loading}>Buscando...</p>
                : resultadosPesquisaCliente.length > 0 ? (
                  <div style={{ maxHeight: 340, overflowY: 'auto' }}>
                    {resultadosPesquisaCliente.map(cliente => {
                      const doc = formatarDocumentoCliente(cliente);
                      const semDocumento = !doc;
                      return (
                        <div key={cliente.idCliente} style={s.clienteResultItem}>
                          <div style={s.clienteResultAvatar}>{(cliente.nome || '?')[0].toUpperCase()}</div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={s.clienteResultNome}>{cliente.nome}</div>
                            <div style={s.clienteResultMeta}>
                              {cliente.telefone && <span>{cliente.telefone}</span>}
                              {doc && <span style={s.docBadge}>{doc}</span>}
                              {semDocumento && (
                                <span style={s.docBadgeAlerta}>
                                  <FaExclamationTriangle size={9} /> CPF/CNPJ obrigatório
                                </span>
                              )}
                            </div>
                          </div>
                          {/* ── CORREÇÃO: botão de editar dados do cliente ao lado do Selecionar ── */}
                          <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                            <button onClick={() => abrirModalEdicaoCliente(cliente)} style={s.btnEditarCliente} title="Editar dados do cliente" disabled={loading}>
                              <FaEdit size={11} />
                            </button>
                            {/* ── NOVO: sem CPF/CNPJ cadastrado, "Selecionar" fica bloqueado —
                                a NFS-e nacional exige o documento pra gerar a DPS. Editar
                                continua liberado; assim que o CPF/CNPJ for salvo, este botão
                                habilita sozinho, porque `doc` é recalculado a cada render. ── */}
                            <button
                              onClick={() => selecionarCliente(cliente)}
                              style={{ ...s.btnPrimary, ...(semDocumento ? s.btnPrimaryDisabled : {}) }}
                              disabled={semDocumento || loading}
                              title={semDocumento ? 'Cadastre o CPF ou CNPJ deste cliente antes de selecionar' : undefined}
                            >
                              <FaCheck size={11} /> Selecionar
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : termoPesquisaCliente.length >= 2 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p style={{ color: '#aaa', fontSize: 13, marginBottom: 12 }}>Nenhum cliente encontrado</p>
                    <button onClick={() => { setModalPesquisaClienteAberto(false); setModalCadastroClienteAberto(true); }} style={s.btnPrimary}><FaUserPlus size={12} /> Cadastrar Novo Cliente</button>
                  </div>
                ) : <p style={{ color: '#bbb', fontSize: 13, textAlign: 'center', padding: '20px 0' }}>Digite pelo menos 2 caracteres</p>
              }
            </div>
          </div>
        </div>
      )}

      {/* ── Modal Cadastro Cliente ── */}
      {modalCadastroClienteAberto && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth: 700, maxHeight: '90vh' }}>
            <div style={s.modalHeader}>
              <span style={s.modalTitle}><FaUserPlus size={14} /> Cadastrar Novo Cliente</span>
              <button onClick={() => { setModalCadastroClienteAberto(false); resetFormCadastroCliente(); }} style={s.modalClose}><FaTimes /></button>
            </div>
            <div style={{ ...s.modalBody, overflowY: 'auto' }}>
              <ImportarPrintCliente valoresAtuais={novoCliente} onDadosLidos={aplicarPrintCadastro} disabled={cadastrandoCliente} />
              <p style={s.sectionLabel}><FaUser size={11} /> Dados Pessoais</p>
              <div style={s.formGroup}>
                <label style={s.label}>Nome *</label>
                <input type="text" value={novoCliente.nome} onChange={(e) => setNovoCliente({...novoCliente, nome: e.target.value})} placeholder="Nome completo" style={{ ...s.input, ...destaquePrintCadastro('nome') }} autoFocus />
                {errorsCliente.nome && <span style={s.errorText}>{errorsCliente.nome}</span>}
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>RG / Identidade</label>
                <input type="text" value={novoCliente.identidade} onChange={(e) => setNovoCliente({...novoCliente, identidade: e.target.value.toUpperCase()})} placeholder="Número do documento" style={s.input} />
                <small style={s.hint}>Usado nos requerimentos do DETRAN</small>
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>E-mail</label>
                <input type="email" value={novoCliente.email} onChange={(e) => setNovoCliente({...novoCliente, email: e.target.value})} placeholder="exemplo@email.com" style={{ ...s.input, ...destaquePrintCadastro('email') }} />
                {errorsCliente.email && <span style={s.errorText}>{errorsCliente.email}</span>}
              </div>
              <div style={s.formRow}>
                <div style={s.formGroup}>
                  <label style={s.label}>CPF <span style={{color: '#e74c3c'}}>*</span></label>
                  <div style={{ position: 'relative' }}>
                    <InputMask mask="999.999.999-99" value={novoCliente.cpf} onChange={handleCpfChange} placeholder="000.000.000-00" style={{ ...s.input, ...destaquePrintCadastro('cpf'), ...getInputBorderStyle(cpfStatus, errorsCliente.cpf) }} />
                    {cpfStatus === 'checking' && <FaSpinner style={s.inputIcon} className="spin" />}
                    {cpfStatus === 'valid' && <FaCheckCircle style={{ ...s.inputIcon, color: '#27ae60' }} />}
                    {(cpfStatus === 'invalid' || cpfStatus === 'duplicate') && <FaTimesCircle style={{ ...s.inputIcon, color: '#e74c3c' }} />}
                  </div>
                  {cpfMessage && <small style={{ fontSize: 11, color: cpfStatus === 'valid' ? '#27ae60' : cpfStatus === 'checking' ? '#f39c12' : '#e74c3c' }}>{cpfMessage}</small>}
                  {errorsCliente.cpf && <span style={s.errorText}>{errorsCliente.cpf}</span>}
                  <small style={s.hint}>CPF ou CNPJ é obrigatório</small>
                </div>
                <div style={s.formGroup}>
                  <label style={s.label}>CNPJ <span style={{color: '#e74c3c'}}>*</span></label>
                  <div style={s.cnpjRow}>
                    <div style={{ position: 'relative', flex: 1, minWidth: 0 }}>
                      <InputMask mask="99.999.999/9999-99" value={novoCliente.cnpj} onChange={handleCnpjChange} placeholder="00.000.000/0000-00" style={{ ...s.input, ...destaquePrintCadastro('cnpj'), ...getInputBorderStyle(cnpjStatus, errorsCliente.cnpj) }} />
                      {cnpjStatus === 'checking' && <FaSpinner style={s.inputIcon} className="spin" />}
                      {cnpjStatus === 'valid' && <FaCheckCircle style={{ ...s.inputIcon, color: '#27ae60' }} />}
                      {(cnpjStatus === 'invalid' || cnpjStatus === 'duplicate') && <FaTimesCircle style={{ ...s.inputIcon, color: '#e74c3c' }} />}
                    </div>
                    <button
                      type="button"
                      onClick={preencherPorCnpj}
                      disabled={!podeConsultarCnpj}
                      title={podeConsultarCnpj ? 'Buscar dados do CNPJ (Receita Federal)' : 'Digite um CNPJ válido para buscar os dados'}
                      style={{ ...s.cnpjButton, ...(!podeConsultarCnpj && s.cnpjButtonDisabled) }}
                    >
                      {buscandoCnpj ? <FaSpinner className="spin" /> : <FaSearch />}
                    </button>
                  </div>
                  {buscandoCnpj && <small style={s.hint}>Consultando CNPJ...</small>}
                  {cnpjMessage && <small style={{ fontSize: 11, color: cnpjStatus === 'valid' ? '#27ae60' : cnpjStatus === 'checking' ? '#f39c12' : '#e74c3c' }}>{cnpjMessage}</small>}
                  {errorsCliente.cnpj && <span style={s.errorText}>{errorsCliente.cnpj}</span>}
                  <small style={s.hint}>CPF ou CNPJ é obrigatório</small>
                </div>
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Telefone</label>
                <InputMask mask="(99) 99999-9999" maskChar={null} value={novoCliente.telefone} onChange={(e) => setNovoCliente({...novoCliente, telefone: e.target.value})} placeholder="(00) 00000-0000" style={{ ...s.input, ...destaquePrintCadastro('telefone') }} />
              </div>
              <p style={{ ...s.sectionLabel, marginTop: 16 }}><FaMapMarkerAlt size={11} /> Endereço</p>
              <div style={s.formRow}>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>CEP <span style={{color: '#e74c3c'}}>*</span></label>
                  <InputMask mask="99999-999" value={novoCliente.cep} onChange={(e) => setNovoCliente({...novoCliente, cep: e.target.value})} onBlur={(e) => { if (cepVeioDoPrint(e.target.value, cepDoPrintCadastro)) return; const c = e.target.value.replace(/\D/g,''); if (c.length === 8) buscarEnderecoPorCEP(e.target.value); }} placeholder="00000-000" style={{ ...s.input, ...destaquePrintCadastro('cep'), ...getInputBorderStyle(null, errorsCliente.cep) }} />
                  {errorsCliente.cep && <span style={s.errorText}>{errorsCliente.cep}</span>}
                  <small style={s.hint}>Preenche o endereço automaticamente</small>
                </div>
                <div style={{ ...s.formGroup, flex: 2 }}>
                  <label style={s.label}>Cidade <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={novoCliente.cidade} onChange={(e) => setNovoCliente({...novoCliente, cidade: e.target.value})} placeholder="Cidade" style={{ ...s.input, ...destaquePrintCadastro('cidade'), ...getInputBorderStyle(null, errorsCliente.cidade) }} />
                  {errorsCliente.cidade && <span style={s.errorText}>{errorsCliente.cidade}</span>}
                </div>
                <div style={{ ...s.formGroup, flex: 0.6 }}>
                  <label style={s.label}>UF <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={novoCliente.uf} onChange={(e) => setNovoCliente({...novoCliente, uf: e.target.value.toUpperCase()})} placeholder="UF" maxLength="2" style={{ ...s.input, ...destaquePrintCadastro('uf'), ...getInputBorderStyle(null, errorsCliente.uf), textTransform: 'uppercase' }} />
                  {errorsCliente.uf && <span style={s.errorText}>{errorsCliente.uf}</span>}
                </div>
              </div>
              <div style={s.formRow}>
                <div style={{ ...s.formGroup, flex: 3 }}>
                  <label style={s.label}>Logradouro <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={novoCliente.logradouro} onChange={(e) => setNovoCliente({...novoCliente, logradouro: e.target.value})} placeholder="Rua, Avenida..." style={{ ...s.input, ...destaquePrintCadastro('logradouro'), ...getInputBorderStyle(null, errorsCliente.logradouro) }} />
                  {errorsCliente.logradouro && <span style={s.errorText}>{errorsCliente.logradouro}</span>}
                </div>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>Número</label>
                  <input type="text" value={novoCliente.numero} onChange={(e) => setNovoCliente({...novoCliente, numero: e.target.value})} placeholder="Nº" style={{ ...s.input, ...destaquePrintCadastro('numero') }} />
                </div>
              </div>
              <div style={s.formRow}>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>Bairro <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={novoCliente.bairro} onChange={(e) => setNovoCliente({...novoCliente, bairro: e.target.value})} placeholder="Bairro" style={{ ...s.input, ...destaquePrintCadastro('bairro'), ...getInputBorderStyle(null, errorsCliente.bairro) }} />
                  {errorsCliente.bairro && <span style={s.errorText}>{errorsCliente.bairro}</span>}
                </div>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>Complemento</label>
                  <input type="text" value={novoCliente.complemento} onChange={(e) => setNovoCliente({...novoCliente, complemento: e.target.value})} placeholder="Apto, sala..." style={{ ...s.input, ...destaquePrintCadastro('complemento') }} />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
                <button onClick={() => { setModalCadastroClienteAberto(false); resetFormCadastroCliente(); }} style={s.btnSecondary}><FaTimes size={11} /> Cancelar</button>
                <button onClick={cadastrarCliente} style={s.btnPrimary} disabled={cadastrandoCliente || !novoCliente.nome}><FaSave size={11} /> {cadastrandoCliente ? 'Cadastrando...' : 'Cadastrar Cliente'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal Edição de Cliente ── */}
      {modalEdicaoClienteAberto && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth: 700, maxHeight: '90vh' }}>
            <div style={{ ...s.modalHeader, background: 'linear-gradient(135deg, #004d4d 0%, #008080 100%)' }}>
              <span style={{ ...s.modalTitle, color: '#fff' }}><FaEdit size={14} /> Editar Dados do Cliente</span>
              <button onClick={fecharModalEdicaoCliente} style={{ ...s.modalClose, color: '#fff' }}><FaTimes /></button>
            </div>
            <div style={{ ...s.modalBody, overflowY: 'auto' }}>
              <ImportarPrintCliente valoresAtuais={formEdicao} onDadosLidos={aplicarPrintEdicao} disabled={salvandoEdicao} />
              <p style={s.sectionLabel}><FaUser size={11} /> Dados Pessoais</p>
              <div style={s.formGroup}>
                <label style={s.label}>Nome *</label>
                <input type="text" value={formEdicao.nome} onChange={(e) => setFormEdicao({...formEdicao, nome: e.target.value})} placeholder="Nome completo" style={{ ...s.input, ...destaquePrintEdicao('nome') }} autoFocus />
                {errorsEdicao.nome && <span style={s.errorText}>{errorsEdicao.nome}</span>}
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>RG / Identidade</label>
                <input type="text" value={formEdicao.identidade} onChange={(e) => setFormEdicao({...formEdicao, identidade: e.target.value.toUpperCase()})} placeholder="Número do documento" style={s.input} />
                <small style={s.hint}>Usado nos requerimentos do DETRAN</small>
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>E-mail</label>
                <input type="email" value={formEdicao.email} onChange={(e) => setFormEdicao({...formEdicao, email: e.target.value})} placeholder="exemplo@email.com" style={{ ...s.input, ...destaquePrintEdicao('email') }} />
                {errorsEdicao.email && <span style={s.errorText}>{errorsEdicao.email}</span>}
              </div>
              <div style={s.formRow}>
                <div style={s.formGroup}>
                  <label style={s.label}>CPF <span style={{color: '#e74c3c'}}>*</span></label>
                  <div style={{ position: 'relative' }}>
                    <InputMask mask="999.999.999-99" value={formEdicao.cpf} onChange={handleCpfChangeEdicao} placeholder="000.000.000-00" style={{ ...s.input, ...destaquePrintEdicao('cpf'), ...getInputBorderStyle(cpfStatusEdicao, errorsEdicao.cpf) }} />
                    {cpfStatusEdicao === 'checking' && <FaSpinner style={s.inputIcon} className="spin" />}
                    {cpfStatusEdicao === 'valid' && <FaCheckCircle style={{ ...s.inputIcon, color: '#27ae60' }} />}
                    {(cpfStatusEdicao === 'invalid' || cpfStatusEdicao === 'duplicate') && <FaTimesCircle style={{ ...s.inputIcon, color: '#e74c3c' }} />}
                  </div>
                  {cpfMessageEdicao && <small style={{ fontSize: 11, color: cpfStatusEdicao === 'valid' ? '#27ae60' : cpfStatusEdicao === 'checking' ? '#f39c12' : '#e74c3c' }}>{cpfMessageEdicao}</small>}
                  {errorsEdicao.cpf && <span style={s.errorText}>{errorsEdicao.cpf}</span>}
                  <small style={s.hint}>CPF ou CNPJ é obrigatório</small>
                </div>
                <div style={s.formGroup}>
                  <label style={s.label}>CNPJ <span style={{color: '#e74c3c'}}>*</span></label>
                  <div style={s.cnpjRow}>
                    <div style={{ position: 'relative', flex: 1, minWidth: 0 }}>
                      <InputMask mask="99.999.999/9999-99" value={formEdicao.cnpj} onChange={handleCnpjChangeEdicao} placeholder="00.000.000/0000-00" style={{ ...s.input, ...destaquePrintEdicao('cnpj'), ...getInputBorderStyle(cnpjStatusEdicao, errorsEdicao.cnpj) }} />
                      {cnpjStatusEdicao === 'checking' && <FaSpinner style={s.inputIcon} className="spin" />}
                      {cnpjStatusEdicao === 'valid' && <FaCheckCircle style={{ ...s.inputIcon, color: '#27ae60' }} />}
                      {(cnpjStatusEdicao === 'invalid' || cnpjStatusEdicao === 'duplicate') && <FaTimesCircle style={{ ...s.inputIcon, color: '#e74c3c' }} />}
                    </div>
                    <button
                      type="button"
                      onClick={preencherPorCnpjEdicao}
                      disabled={!podeConsultarCnpjEdicao}
                      title={podeConsultarCnpjEdicao ? 'Completar os campos em branco com os dados do CNPJ (Receita Federal)' : 'Digite um CNPJ válido para buscar os dados'}
                      style={{ ...s.cnpjButton, ...(!podeConsultarCnpjEdicao && s.cnpjButtonDisabled) }}
                    >
                      {buscandoCnpjEdicao ? <FaSpinner className="spin" /> : <FaSearch />}
                    </button>
                  </div>
                  {buscandoCnpjEdicao && <small style={s.hint}>Consultando CNPJ...</small>}
                  {cnpjMessageEdicao && <small style={{ fontSize: 11, color: cnpjStatusEdicao === 'valid' ? '#27ae60' : cnpjStatusEdicao === 'checking' ? '#f39c12' : '#e74c3c' }}>{cnpjMessageEdicao}</small>}
                  {errorsEdicao.cnpj && <span style={s.errorText}>{errorsEdicao.cnpj}</span>}
                  <small style={s.hint}>CPF ou CNPJ é obrigatório</small>
                </div>
              </div>
              <div style={s.formGroup}>
                <label style={s.label}>Telefone</label>
                <InputMask mask="(99) 99999-9999" maskChar={null} value={formEdicao.telefone} onChange={(e) => setFormEdicao({...formEdicao, telefone: e.target.value})} placeholder="(00) 00000-0000" style={{ ...s.input, ...destaquePrintEdicao('telefone') }} />
              </div>
              <p style={{ ...s.sectionLabel, marginTop: 16 }}><FaMapMarkerAlt size={11} /> Endereço</p>
              <div style={s.formRow}>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>CEP <span style={{color: '#e74c3c'}}>*</span></label>
                  <InputMask mask="99999-999" value={formEdicao.cep} onChange={(e) => setFormEdicao({...formEdicao, cep: e.target.value})} onBlur={(e) => { if (cepVeioDoPrint(e.target.value, cepDoPrintEdicao)) return; const c = e.target.value.replace(/\D/g,''); if (c.length === 8) buscarEnderecoPorCEPEdicao(e.target.value); }} placeholder="00000-000" style={{ ...s.input, ...destaquePrintEdicao('cep'), ...getInputBorderStyle(null, errorsEdicao.cep) }} />
                  {errorsEdicao.cep && <span style={s.errorText}>{errorsEdicao.cep}</span>}
                  <small style={s.hint}>{loadingCepEdicao ? 'Buscando endereço...' : 'Preenche o endereço automaticamente'}</small>
                </div>
                <div style={{ ...s.formGroup, flex: 2 }}>
                  <label style={s.label}>Cidade <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={formEdicao.cidade} onChange={(e) => setFormEdicao({...formEdicao, cidade: e.target.value})} placeholder="Cidade" style={{ ...s.input, ...destaquePrintEdicao('cidade'), ...getInputBorderStyle(null, errorsEdicao.cidade) }} />
                  {errorsEdicao.cidade && <span style={s.errorText}>{errorsEdicao.cidade}</span>}
                </div>
                <div style={{ ...s.formGroup, flex: 0.6 }}>
                  <label style={s.label}>UF <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={formEdicao.uf} onChange={(e) => setFormEdicao({...formEdicao, uf: e.target.value.toUpperCase()})} placeholder="UF" maxLength="2" style={{ ...s.input, ...destaquePrintEdicao('uf'), ...getInputBorderStyle(null, errorsEdicao.uf), textTransform: 'uppercase' }} />
                  {errorsEdicao.uf && <span style={s.errorText}>{errorsEdicao.uf}</span>}
                </div>
              </div>
              <div style={s.formRow}>
                <div style={{ ...s.formGroup, flex: 3 }}>
                  <label style={s.label}>Logradouro <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={formEdicao.logradouro} onChange={(e) => setFormEdicao({...formEdicao, logradouro: e.target.value})} placeholder="Rua, Avenida..." style={{ ...s.input, ...destaquePrintEdicao('logradouro'), ...getInputBorderStyle(null, errorsEdicao.logradouro) }} />
                  {errorsEdicao.logradouro && <span style={s.errorText}>{errorsEdicao.logradouro}</span>}
                </div>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>Número</label>
                  <input type="text" value={formEdicao.numero} onChange={(e) => setFormEdicao({...formEdicao, numero: e.target.value})} placeholder="Nº" style={{ ...s.input, ...destaquePrintEdicao('numero') }} />
                </div>
              </div>
              <div style={s.formRow}>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>Bairro <span style={{color: '#e74c3c'}}>*</span></label>
                  <input type="text" value={formEdicao.bairro} onChange={(e) => setFormEdicao({...formEdicao, bairro: e.target.value})} placeholder="Bairro" style={{ ...s.input, ...destaquePrintEdicao('bairro'), ...getInputBorderStyle(null, errorsEdicao.bairro) }} />
                  {errorsEdicao.bairro && <span style={s.errorText}>{errorsEdicao.bairro}</span>}
                </div>
                <div style={{ ...s.formGroup, flex: 1 }}>
                  <label style={s.label}>Complemento</label>
                  <input type="text" value={formEdicao.complemento} onChange={(e) => setFormEdicao({...formEdicao, complemento: e.target.value})} placeholder="Apto, sala..." style={{ ...s.input, ...destaquePrintEdicao('complemento') }} />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
                <button onClick={fecharModalEdicaoCliente} style={s.btnSecondary}><FaTimes size={11} /> Cancelar</button>
                <button onClick={salvarEdicaoCliente} style={s.btnPrimary} disabled={salvandoEdicao || !formEdicao.nome}><FaSave size={11} /> {salvandoEdicao ? 'Salvando...' : 'Salvar Alterações'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal Sucesso ao Salvar Ordem ── */}
      {modalSucessoAberto && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth: 420 }}>
            <div style={s.modalHeader}>
              <span style={s.modalTitle}><FaCheck size={14} style={{ color: '#27ae60' }} /> Ordem de Serviço Salva</span>
            </div>
            <div style={{ ...s.modalBody, textAlign: 'center' }}>
              <p style={{ fontSize: 13, color: '#555', margin: '0 0 20px' }}>O que você deseja fazer agora?</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <button onClick={verImprimirOrdem} style={s.btnPrimary} disabled={gerandoRecibo}>
                  <FaFileAlt size={12} /> {gerandoRecibo ? 'Abrindo...' : 'Ver/Imprimir'}
                </button>
                <button onClick={gerarNovoProtocolo} style={s.btnEditarCliente}>
                  <FaClipboardList size={12} /> Gerar Novo Protocolo de Atendimento
                </button>
                {/* ── NOVO: botão "Nova Ordem de Serviço" entre o protocolo e o fechar ── */}
                <button onClick={novaOrdemServicoAposSalvar} style={s.btnNovaOrdem}>
                  <FaPlus size={12} /> Nova Ordem de Serviço
                </button>
                <button onClick={fecharModalSucesso} style={s.btnSecondary}>
                  <FaTimes size={12} /> Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin { from { transform: translateY(-50%) rotate(0deg); } to { transform: translateY(-50%) rotate(360deg); } }
        .spin { animation: spin 1s linear infinite; }
        .disponivel-item:hover { background: #e8f8f5 !important; }
        .selecionados-scroll::-webkit-scrollbar { width: 5px; }
        .selecionados-scroll::-webkit-scrollbar-track { background: transparent; }
        .selecionados-scroll::-webkit-scrollbar-thumb { background: #d0ebe8; border-radius: 4px; }
        .disponivel-list::-webkit-scrollbar { width: 5px; }
        .disponivel-list::-webkit-scrollbar-track { background: transparent; }
        .disponivel-list::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 4px; }

        .ordem-servico-page > header,
        .ordem-servico-page > div:first-child > header {
          flex-shrink: 0;
        }

        @media (max-height: 700px) {
          .ordem-servico-wrap { padding-top: 10px !important; padding-bottom: 10px !important; gap: 8px !important; }
          .ordem-servico-painel { padding: 10px 14px !important; }
        }

        @media (max-height: 480px) {
          .ordem-servico-page { height: auto !important; min-height: 100vh !important; overflow: auto !important; }
        }

        @media (max-width: 860px) {
          .ordem-servico-grid { grid-template-columns: 1fr !important; }
          .ordem-servico-page { height: auto !important; min-height: 100vh !important; overflow: auto !important; }
          .ordem-servico-wrap { overflow: visible !important; }
          .ordem-servico-painel { flex: none !important; height: 360px !important; min-height: 360px !important; }
        }
      `}</style>
    </div>
  );
}

const s = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: '#f0f4f8',
    fontFamily: "'Segoe UI', sans-serif",
    overflow: 'hidden',
  },

  wrap: {
    flex: 1,
    minHeight: 0,
    maxWidth: 1300,
    margin: '0 auto',
    width: '100%',
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    overflow: 'hidden',
    boxSizing: 'border-box',
  },

  pageHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, flexShrink: 0 },
  pageHeaderLeft: { display: 'flex', alignItems: 'center', gap: 14 },
  pageHeaderIcon: { fontSize: 28, color: '#008080' },
  pageTitle: { margin: 0, fontSize: 20, fontWeight: 700, color: '#1a2e35' },
  pageSubtitle: { margin: '2px 0 0', fontSize: 12, color: '#7f8c8d' },

  card: { background: '#fff', borderRadius: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.07)', padding: '14px 18px', flexShrink: 0 },

  painelCard: {
    background: '#fff',
    borderRadius: 10,
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    padding: '14px 18px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },

  cardHeader: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, flexShrink: 0 },
  cardTitle: { fontSize: 13, fontWeight: 700, color: '#2c3e50', flex: 1 },
  cardHint: { fontSize: 10, color: '#bbb', fontStyle: 'italic' },

  clienteRow: { display: 'flex', alignItems: 'center', gap: 12 },
  clienteAvatar: { width: 38, height: 38, minWidth: 38, borderRadius: '50%', background: 'linear-gradient(135deg, #008080, #20b2aa)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 16 },
  clienteInfo: { flex: 1, display: 'flex', flexDirection: 'column', gap: 3 },
  clienteNome: { fontWeight: 600, fontSize: 14, color: '#1a2e35' },
  clienteMeta: { display: 'flex', gap: 14, fontSize: 11, color: '#7f8c8d' },

  produtosGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, alignItems: 'stretch', flex: 1, minHeight: 0 },

  selecionadosList: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    paddingRight: 4,
    className: 'selecionados-scroll',
    scrollbarWidth: 'thin',
    scrollbarColor: '#d0ebe8 transparent',
  },

  selecionadoCard: { background: '#f8fffe', border: '1px solid #e0f5f2', borderRadius: 8, padding: '10px 12px', flexShrink: 0 },
  selecionadoHeader: { display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8 },
  selecionadoNome: { display: 'block', fontWeight: 600, fontSize: 12, color: '#1a2e35' },
  selecionadoDesc: { display: 'block', fontSize: 10, color: '#999', marginTop: 2 },
  selecionadoAcoes: { display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 },
  qtdControle: { display: 'flex', alignItems: 'center', gap: 4, background: '#eef', borderRadius: 6, padding: '2px 4px' },
  qtdBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#008080', padding: '2px 4px', borderRadius: 4, display: 'flex', alignItems: 'center' },
  qtdInput: { width: 28, textAlign: 'center', border: 'none', background: 'transparent', fontSize: 12, fontWeight: 700, color: '#2c3e50', outline: 'none', padding: 0, MozAppearance: 'textfield' },
  subtotal: { fontSize: 12, fontWeight: 700, color: '#27ae60', whiteSpace: 'nowrap' },
  btnRemove: { background: 'none', border: 'none', cursor: 'pointer', color: '#e74c3c', padding: 4, display: 'flex', alignItems: 'center', borderRadius: 4 },
  placaRow: { display: 'flex', gap: 6, alignItems: 'center', marginBottom: 4 },
  inputPlaca: { flex: 1, padding: '4px 8px', border: '1px solid #e0e0e0', borderRadius: 5, fontSize: 11, textTransform: 'uppercase', background: '#fff' },
  inputDoc: { flex: 1.5, padding: '4px 8px', border: '1px solid #e0e0e0', borderRadius: 5, fontSize: 11, textTransform: 'uppercase', background: '#fff' },
  btnAddPlaca: { background: 'none', border: 'none', cursor: 'pointer', color: '#008080', fontSize: 10, display: 'flex', alignItems: 'center', gap: 4, padding: '4px 0', fontWeight: 500 },

  disponivelList: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#e0e0e0 transparent',
  },

  disponivelItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 10px', borderRadius: 6, cursor: 'pointer', transition: 'background 0.15s', marginBottom: 2 },
  disponivelNome: { fontSize: 12, fontWeight: 500, color: '#2c3e50' },
  disponivelPreco: { fontSize: 12, fontWeight: 700, color: '#27ae60', fontFamily: 'monospace', flexShrink: 0 },

  emptyState: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' },

  obsToggle: { width: '100%', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, padding: 0, textAlign: 'left' },
  obsTextarea: { width: '100%', marginTop: 10, padding: '10px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 13, resize: 'vertical', fontFamily: 'inherit', background: '#fafeff', boxSizing: 'border-box' },

  footer: { background: '#fff', borderRadius: 10, padding: '12px 18px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, flexShrink: 0 },
  footerLeft: { display: 'flex', gap: 10 },
  footerRight: { display: 'flex', gap: 12, alignItems: 'center' },
  issqnBadge: { display: 'flex', alignItems: 'center', gap: 10, background: '#fff8ee', border: '1px solid #ffe0b2', borderRadius: 8, padding: '8px 14px' },
  totalBadge: { display: 'flex', alignItems: 'center', gap: 10, background: '#f0fdf4', border: '1px solid #c3e6cb', borderRadius: 8, padding: '8px 14px' },
  badgeLabel: { display: 'block', fontSize: 9, color: '#888', textTransform: 'uppercase', letterSpacing: 1 },
  issqnValue: { display: 'block', fontSize: 18, fontWeight: 700, color: '#e65100' },
  totalValue: { display: 'block', fontSize: 18, fontWeight: 700, color: '#27ae60', fontFamily: 'monospace' },

  btnPrimary: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 16px', background: 'linear-gradient(135deg, #008080, #20b2aa)', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600, transition: 'opacity 0.2s' },
  btnPrimaryDisabled: { background: '#bdc3c7', cursor: 'not-allowed', opacity: 0.8 },
  btnSecondary: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 14px', background: '#f0f4f8', color: '#555', border: '1px solid #ddd', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 },
  btnOutline: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px', background: 'transparent', color: '#008080', border: '1.5px solid #008080', borderRadius: 7, cursor: 'pointer', fontSize: 11, fontWeight: 600 },
  btnEditarCliente: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 12px', background: 'linear-gradient(135deg, #e07030, #f0a060)', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 },
  // ── NOVO: estilo do botão "Nova Ordem de Serviço" no modal de sucesso ──
  btnNovaOrdem: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 12px', background: 'linear-gradient(135deg, #2c3e50, #34495e)', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 },

  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modal: { background: '#fff', borderRadius: 12, width: '92%', maxWidth: 560, maxHeight: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 12px 40px rgba(0,0,0,0.18)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fafffe' },
  modalTitle: { fontWeight: 700, fontSize: 14, color: '#1a2e35', display: 'flex', alignItems: 'center', gap: 8 },
  modalClose: { background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#aaa', lineHeight: 1 },
  modalBody: { padding: '16px 20px', flex: 1, overflowY: 'auto' },

  formGroup: { display: 'flex', flexDirection: 'column', gap: 5, marginBottom: 12 },
  formRow: { display: 'flex', gap: 12, flexWrap: 'wrap' },
  label: { fontSize: 11, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.4 },
  input: { padding: '8px 10px', border: '1.5px solid #e0e0e0', borderRadius: 7, fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box', transition: 'border-color 0.2s' },
  hint: { fontSize: 10, color: '#aaa', fontStyle: 'italic' },
  sectionLabel: { fontSize: 11, fontWeight: 700, color: '#008080', textTransform: 'uppercase', letterSpacing: 0.6, display: 'flex', alignItems: 'center', gap: 6, margin: '0 0 10px', paddingBottom: 6, borderBottom: '1px solid #f0f0f0' },
  inputIcon: { position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', color: '#aaa' },
  cnpjRow: { display: 'flex', gap: 6, alignItems: 'stretch' },
  cnpjButton: { backgroundColor: '#3498db', color: '#fff', border: 'none', padding: '0 14px', borderRadius: 6, fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center' },
  cnpjButtonDisabled: { backgroundColor: '#b8c2cc', cursor: 'not-allowed' },
  errorText: { fontSize: 11, color: '#e74c3c', marginTop: 2 },
  // Filtro da lista de produtos disponíveis (mesmo estilo do Truck Control)
  filtroBox: { display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', border: '1.5px solid #e0e0e0', borderRadius: 7, marginBottom: 8, backgroundColor: '#fafafa' },
  filtroIcone: { color: '#9ca3af', fontSize: 12, flexShrink: 0 },
  filtroInput: { border: 'none', outline: 'none', background: 'transparent', flex: 1, minWidth: 0, fontSize: 13 },
  filtroLimpar: { border: 'none', background: 'transparent', color: '#9ca3af', cursor: 'pointer', display: 'flex', alignItems: 'center', padding: 2 },
  searchInput: { width: '100%', padding: '9px 12px', border: '1.5px solid #e0e0e0', borderRadius: 7, fontSize: 13, outline: 'none', boxSizing: 'border-box', marginBottom: 8 },

  clienteResultItem: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 4px', borderBottom: '1px solid #f5f5f5' },
  clienteResultAvatar: { width: 34, height: 34, minWidth: 34, borderRadius: '50%', background: 'linear-gradient(135deg, #008080, #20b2aa)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14 },
  clienteResultNome: { fontWeight: 600, fontSize: 13, color: '#1a2e35', marginBottom: 2 },
  clienteResultMeta: { display: 'flex', gap: 10, fontSize: 11, color: '#999', alignItems: 'center', flexWrap: 'wrap' },
  docBadge: { background: '#e8f8f5', color: '#008080', border: '1px solid #b2e0da', borderRadius: 4, padding: '1px 6px', fontSize: 10, fontWeight: 600 },
  docBadgeAlerta: { display: 'inline-flex', alignItems: 'center', gap: 4, background: '#fff5eb', color: '#e07030', border: '1px solid #ffd8b0', borderRadius: 4, padding: '1px 6px', fontSize: 10, fontWeight: 600 },
  loading: { textAlign: 'center', color: '#aaa', fontSize: 13, padding: 20 },
};

export default OrdemServico;
